interface TutorLegalFieldOptions {
  onUpdate: (value: string) => void
}

interface TutorLegalFieldReturn {
  setValue: (value: string | number) => void
}

export const useTutorLegalField = ({ onUpdate }: TutorLegalFieldOptions): TutorLegalFieldReturn => {
  const setValue = (value: string | number): void => onUpdate(String(value))

  return {
    setValue,
  }
}
